import { Link } from "wouter";
import { MarketingLayout } from "./layouts.js";
import { Button } from "@/components/ui/button";

export function HomePage() {
  return (
    <MarketingLayout>
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="text-center">
          <h1 className="text-4xl font-bold tracking-tight sm:text-5xl">
            Welcome to Scantling
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            Your content workflow, simplified.
          </p>
          <div className="mt-8 flex justify-center gap-4">
            <Button asChild size="lg">
              <Link href="/login">Get Started</Link>
            </Button>
            <Button asChild variant="outline" size="lg">
              <Link href="/docs">Docs</Link>
            </Button>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}
